import { fetchFolderFileNameAPI } from '../Redux/ApiCalls/Dashboard/FolderApi'

/** Normalize for comparison (basename with extension, lowercase). */
export function normalizeUploadFileName(name: string): string {
  return (name.split('/').pop() || name).trim().toLowerCase()
}

export async function fetchExistingFolderFileNames(
  folderId: number,
): Promise<Set<string>> {
  try {
    const res = await fetchFolderFileNameAPI(String(folderId))
    const raw =
      (res as { file_names?: string[] })?.file_names ??
      (res as { data?: { file_names?: string[] } })?.data?.file_names ??
      []
    return new Set(
      Array.isArray(raw) ? raw.map((n) => normalizeUploadFileName(String(n))) : [],
    )
  } catch {
    return new Set()
  }
}

export function partitionFilesByExisting(
  files: File[],
  existingNames: Set<string>,
): { toUpload: File[]; skippedAsDuplicate: File[] } {
  const toUpload: File[] = []
  const skippedAsDuplicate: File[] = []
  for (const file of files) {
    if (existingNames.has(normalizeUploadFileName(file.name))) {
      skippedAsDuplicate.push(file)
    } else {
      toUpload.push(file)
    }
  }
  return { toUpload, skippedAsDuplicate }
}
